exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".summary-location{display:inline-block;top:50%;left:50%;transform:translate(-50%,-50%);font-size:24px;position:absolute;z-index:5;text-align:center;width:80%;margin:auto;white-space:normal;cursor:pointer;color:#fff;background-color:rgba(0,0,0,.5)}.summary-location:hover{color:#3cb449}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/summary.less
// module id = 2231
// module chunks = 0